import { render, staticRenderFns } from "./BrineIngredients.vue?vue&type=template&id=1e915d46&scoped=true"
import script from "./BrineIngredients.vue?vue&type=script&lang=js"
export * from "./BrineIngredients.vue?vue&type=script&lang=js"
import style0 from "./BrineIngredients.vue?vue&type=style&index=0&id=1e915d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e915d46",
  null
  
)

export default component.exports